var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.095 9.667c-1.683-3.909-4.85-6.334-8.267-6.334S4.245 5.758 2.562 9.667a.83.83 0 0 0 0 .666c1.683 3.909 4.85 6.334 8.266 6.334s6.584-2.425 8.267-6.334a.83.83 0 0 0 0-.666M10.828 15c-2.641 0-5.141-1.908-6.583-5 1.442-3.092 3.942-5 6.583-5s5.142 1.908 6.584 5c-1.442 3.092-3.942 5-6.584 5m0-8.333a3.333 3.333 0 1 0 0 6.667 3.333 3.333 0 0 0 0-6.667m0 5a1.667 1.667 0 1 1 0-3.334 1.667 1.667 0 0 1 0 3.334"
  })));
};
export default SvgEye;